import { MenuItem } from 'primeng/api'

export const UI_MENU: MenuItem[] = [
    {
        label: 'Draft',
        icon: 'drafts',
        routerLink: '/labourSheets/status/draft',
        state: {
            hasBadge: true,
            badgeCount: 0,
            active: false
        }
    },
    {
        label: 'Pending',
        icon: 'access_time',
        routerLink: '/labourSheets/status/pending',
        state: {
            hasBadge: true,
            badgeCount: 0,
            active: false
        }
    },
    {
        label: 'Completed',
        icon: 'check_circle',
        routerLink: '/labourSheets/status/completed',
        state: {
            hasBadge: true,
            badgeCount: 0,
            active: false
        }
    },
    {
        label: 'Closed',
        icon: 'lock',
        routerLink: '/labourSheets/status/closed',
        state: {
            hasBadge: false,
            badgeCount: 0,
            active: false
        }
    }
]

export const USER_MENU: MenuItem[] = [
    {
        label: 'Maintain Employees',
        icon: 'people',
        routerLink: '/admin/employees'
    },
    {
        label: 'Maintain Skills',
        icon: 'build',
        routerLink: '/admin/skills'
    },
    {
        label: 'Maintain Leave',
        icon: 'beach_access',
        routerLink: 'admin/leaves'
    },
    {
        label: 'splitter'
    },
    {
        label: 'Maintain Ships',
        icon: 'directions_boat',
        routerLink: '/admin/ships'
    },
    {
        label: 'Maintain Ship types',
        icon: 'directions_boat',
        routerLink: '/admin/shipTypes'
    }
]
